import { makeStyles } from 'tss-react/mui';

import { PILL_RADIUS_PX } from '../../constants';

/** Styles for the shared suggestion chip primitive (layout and interaction states). */
const useStyles = makeStyles()((theme) => ({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.new.spacing.small} ${theme.new.spacing.medium}`,
    borderRadius: PILL_RADIUS_PX,
    border: `1px solid ${theme.new.color.brand[600]}`,
    backgroundColor: theme.new.color.common.white,
    ...theme.typography.small_body_regular,
    lineHeight: 1.6,
    color: theme.new.color.textPrimary,
    cursor: 'pointer',
    textTransform: 'none',
    transition: theme.transitions.create([
      'background-color',
      'border-color',
      'color',
    ]),
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:hover': {
      backgroundColor: theme.new.color.brand[100],
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.new.color.brand[600]}`,
      outlineOffset: 2,
    },
  },
  chipSelected: {
    backgroundColor: theme.new.color.brand[100],
    borderColor: theme.new.color.brand[600],
    color: theme.new.color.brand[600],
  },
}));

export default useStyles;
